import type { LangListItem } from "../api/generated"

export const DEFAULT_LANG_LIST: LangListItem[] = [
  {
    lang: "en",
    label: "ENGLISH",
  },
  {
    lang: "sq",
    label: "ALBANIAN",
  },
  {
    lang: "ar",
    label: "ARABIC",
  },
  {
    lang: "az",
    label: "AZERBAIJANI",
  },
  {
    lang: "bn",
    label: "BENGALI",
  },
  {
    lang: "bg",
    label: "BULGARIAN",
  },
  {
    lang: "ca",
    label: "CATALAN",
  },
  {
    lang: "zh",
    label: "CHINESE",
  },
  {
    lang: "cs",
    label: "CZECH",
  },
  {
    lang: "da",
    label: "DANISH",
  },
  {
    lang: "nl",
    label: "DUTCH",
  },
  {
    lang: "eo",
    label: "ESPERANTO",
  },
  {
    lang: "et",
    label: "ESTONIAN",
  },
  {
    lang: "fi",
    label: "FINNISH",
  },
  {
    lang: "fr",
    label: "FRENCH",
  },
  {
    lang: "de",
    label: "GERMAN",
  },
  {
    lang: "el",
    label: "GREEK",
  },
  {
    lang: "iw",
    label: "HEBREW",
  },
  {
    lang: "hi",
    label: "HINDI",
  },
  {
    lang: "hu",
    label: "HUNGARIAN",
  },
  {
    lang: "ga",
    label: "IRISH",
  },
  {
    lang: "it",
    label: "ITALIAN",
  },
  {
    lang: "ja",
    label: "JAPANESE",
  },
  {
    lang: "ko",
    label: "KOREAN",
  },
  {
    lang: "lv",
    label: "LATVIAN",
  },
  {
    lang: "lt",
    label: "LITHUANIAN",
  },
  {
    lang: "ms",
    label: "MALAY",
  },
  {
    lang: "no",
    label: "NORWEGIAN",
  },
  {
    lang: "fa",
    label: "PERSIAN",
  },
  {
    lang: "pl",
    label: "POLISH",
  },
  {
    lang: "pt",
    label: "PORTUGUESE",
  },
  {
    lang: "ro",
    label: "ROMANIAN",
  },
  {
    lang: "ru",
    label: "RUSSIAN",
  },
  {
    lang: "sk",
    label: "SLOVAK",
  },
  {
    lang: "sl",
    label: "SLOVENIAN",
  },
  {
    lang: "es",
    label: "SPANISH",
  },
  {
    lang: "sv",
    label: "SWEDISH",
  },
  {
    lang: "tl",
    label: "FILIPINO",
  },
  {
    lang: "th",
    label: "THAI",
  },
  {
    lang: "tr",
    label: "TURKISH",
  },
  {
    lang: "uk",
    label: "UKRAINIAN",
  },
  {
    lang: "ur",
    label: "URDU",
  },
]
